import SimpleFloatingEdge from '../../Pages/Operation/SimpleFloatingEdge';

const edgeTypes = {
  floating: SimpleFloatingEdge,
}

export default edgeTypes;